export interface ProviderConfig {
  provider: string;
  providerName: string;
}

export type ProviderMap = {
  [slug: string]: ProviderConfig;
};

// The keys are the supported URL slugs for /login/sso/:slug . The values are
// used as the objects in the signInOptions array for firebase
// https://github.com/firebase/firebaseui-web#configure-oauth-providers
export const providerMap: ProviderMap = {
  "auth0-test": {
    provider: "oidc.auth0-test",
    providerName: "Auth0",
  },
  bcbsnc: {
    provider: "saml.bcbsnc",
    providerName: "Blue Cross Blue Shield of North Carolina",
  },
  carbonhealth: {
    provider: "saml.carbonhealth",
    providerName: "Carbon Health",
  },
  "modern-health": {
    provider: "saml.modern-health",
    providerName: "Okta",
  },
  cerebral: {
    provider: "saml.cerebral",
    providerName: "Okta",
  },
  "yale-school-of-medicine": {
    provider: "saml.yale-school-of-medicine",
    providerName: "Yale",
  },
  "yale-new-haven-health": {
    provider: "saml.yale-new-haven-health",
    providerName: "Yale New Haven Health",
  },
  "jumpcloud-sso-test": {
    provider: "saml.jumpcloud-sso-test",
    providerName: "Freshpaint Jumpcloud SSO Test",
  },
  "unc-health": {
    provider: "saml.unc-health",
    providerName: "UNC Health",
  },
  "inova-health": {
    provider: "saml.inova",
    providerName: "Inova Health",
  },
  heartland: {
    provider: "saml.heartland",
    providerName: "Heartland Dental",
  },
  jefferson: {
    provider: "saml.jefferson",
    providerName: "Jefferson",
  },
  caresource: {
    provider: "saml.caresource",
    providerName: "Okta",
  },
  alpine: {
    provider: "saml.alpine",
    providerName: "Alpine",
  },
  betabionics: {
    provider: "saml.betabionics",
    providerName: "Beta Bionics",
  },
  rogersbh: {
    provider: "saml.rogersbh",
    providerName: "Rogers Behavioral Health",
  },
  virtahealth: {
    provider: "saml.virtahealth",
    providerName: "Virta Health",
  },
  "eyecare-partners": {
    provider: "saml.eyecare-partners",
    providerName: "EyeCare Partners",
  },
  "prisma-health": {
    provider: "saml.prisma-health",
    providerName: "Prisma Health",
  },
  gohealth: {
    provider: "saml.gohealth",
    providerName: "GoHealth",
  },
  geha: {
    provider: "saml.geha",
    providerName: "GEHA",
  },
  kphhealthcare: {
    provider: "saml.kphhealthcare",
    providerName: "KPH Healthcare Services, Inc",
  },
  tempus: {
    provider: "saml.tempus",
    providerName: "Tempus",
  },
  cigna: {
    provider: "saml.cigna",
    providerName: "Cigna",
  },
  nuvancehealth: {
    provider: "saml.nuvancehealth",
    providerName: "Nuvance Health",
  },
  "warby-parker": {
    provider: "saml.warby-parker",
    providerName: "Warby Parker",
  },
  lifemd: {
    provider: "saml.lifemd",
    providerName: "LifeMD",
  },
  "medi-weightloss": {
    provider: "saml.medi-weightloss",
    providerName: "Medi-Weightloss",
  },
  functionhealth: {
    provider: "saml.functionhealth",
    providerName: "Function Health",
  },
  meridianhs: {
    provider: "saml.meridianhs",
    providerName: "Meridian HS",
  },
  medtronic: {
    provider: "saml.medtronic",
    providerName: "Medtronic",
  },
  intermountain: {
    provider: "saml.intermountain",
    providerName: "Intermountain Health",
  },
  baystate: {
    provider: "saml.baystate",
    providerName: "Baystate Health",
  },
  hcsc: {
    provider: "saml.hcsc",
    providerName: "HCSC",
  },
  forefrontderm: {
    provider: "saml.forefrontderm",
    providerName: "forefrontderm",
  },
  solera: {
    provider: "saml.solera",
    providerName: "Solera",
  },
  bouldercare: {
    provider: "saml.bouldercare",
    providerName: "bouldercare",
  },
  nmhs: {
    provider: "saml.nmhs",
    providerName: "NMHS",
  },
  equiphealth: {
    provider: "saml.equiphealth",
    providerName: "Equip Health",
  },
  bronsonhg: {
    provider: "saml.bronsonhg",
    providerName: "Bronson Healthcare",
  },
  growtherapy: {
    provider: "saml.growtherapy",
    providerName: "Grow Therapy",
  },
  lyrahealth: {
    provider: "saml.lyrahealth",
    providerName: "Lyra Health",
  },
  bendhealth: {
    provider: "saml.bendhealth",
    providerName: "Bend Health",
  },
  "mvp-healthcare": {
    provider: "saml.mvp-healthcare",
    providerName: "MVP Healthcare",
  },
  vcuhealth: {
    provider: "saml.vcuhealth",
    providerName: "VCU Health",
  },
  afcurgentcare: {
    provider: "saml.afcurgentcare",
    providerName: "American Family Care",
  },
  healthfirst: {
    provider: "saml.healthfirst",
    providerName: "Healthfirst",
  },
  tcomn: {
    provider: "saml.tcomn",
    providerName: "Twin Cities Orthopedics",
  },
  akronchildrens: {
    provider: "saml.akronchildrens",
    providerName: "Akron Children's Hospital",
  },
};
